import AppLogoIcon from "@/components/app-logo-icon"
import { Link } from "@/components/ui/link"
import { dashboardPath } from "@/routes"

import { cx } from "@uui/utils/cx"

interface BrandLockupProps {
  className?: string
}

/**
 * The authenticated shell's brand mark — the public footer's lockup
 * (`public-footer.tsx`) drawn for the cream rail: a soft highlighter-tint tile
 * holding the ink app glyph beside the wordmark. Shared by the desktop rail and
 * the mobile header so the mark never drifts. Links home to the dashboard.
 */
export const BrandLockup = ({ className }: BrandLockupProps) => {
  return (
    <Link
      href={dashboardPath()}
      variant="muted"
      aria-label="Lists"
      className={cx(
        "group outline-focus-ring inline-flex items-center gap-2.5 rounded-md transition hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2",
        className,
      )}
    >
      <span className="bg-batyr-yellow/20 ring-batyr-yellow/30 group-hover:bg-batyr-yellow/30 inline-flex size-9 shrink-0 items-center justify-center rounded-xl ring-1 transition-colors">
        <AppLogoIcon aria-hidden="true" className="text-primary size-5" />
      </span>
      <span className="text-primary text-lg font-extrabold tracking-tight">
        Lists
      </span>
    </Link>
  )
}
